// extracted by mini-css-extract-plugin
export default {"img_container":"Partners_img_container__4L+VX"};